import { render } from "./vredpacketdetailed.vue?vue&type=template&id=49c03c1e&scoped=true"
import script from "./vredpacketdetailed.vue?vue&type=script&lang=js"
export * from "./vredpacketdetailed.vue?vue&type=script&lang=js"

import "./vredpacketdetailed.vue?vue&type=style&index=0&id=49c03c1e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c03c1e"]])

export default __exports__